import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface BulkDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  itemType: 'timelines' | 'chapters' | 'cards';
  itemCount: number;
  onConfirm: () => void;
  isDeleting: boolean;
}

export const BulkDeleteDialog: React.FC<BulkDeleteDialogProps> = ({
  open,
  onOpenChange,
  itemType,
  itemCount,
  onConfirm,
  isDeleting
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-destructive">
            <AlertTriangle className="h-5 w-5" />
            Delete {itemCount} {itemType}
          </DialogTitle>
          <DialogDescription>
            Are you sure you want to delete {itemCount} {itemType}? This action cannot be undone.
            {itemType === 'timelines' && (
              <div className="mt-2 text-destructive font-medium">
                Warning: Deleting timelines will also delete all associated plot cards.
              </div>
            )}
            {itemType === 'chapters' && (
              <div className="mt-2 text-destructive font-medium">
                Warning: Deleting chapters will also delete all associated plot cards.
              </div>
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isDeleting}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : `Delete ${itemCount} ${itemType}`}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
